module.exports = __webpack_public_path__ + "resources/img/Background.39f65e99.svg";